import { useSearchLocationPopularDestinations } from '@/constants/search';
import { usePopularParks } from '@/graphql/hooks/search/getPopularParks';

export const usePopularDestinations = () => {
  const searchLocationPopularDestinations = useSearchLocationPopularDestinations();
  const parksResponse = usePopularParks(searchLocationPopularDestinations);

  const popularDestinationsByLocation = parksResponse?.map(park => ({
    label: park?.label,
    sublabel: park?.sublabel,
    value: park?.value,
  }));

  return popularDestinationsByLocation.length
    ? popularDestinationsByLocation
    : searchLocationPopularDestinations;
};
